module.exports = __webpack_public_path__ + "static/media/IMG_2421.7d6eb157.JPG";